<template>

  <div class="grafico-corretiva" >

  </div>  

  
  



</template>


<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'



export default {

    name: 'ManutencaoRfiLancamento',    

    data: function() {
      
        return {          
          

        }        
    },

    methods: {

      },

      loadDashCorretiva() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`  
          axios.get(url).then(res => {
            this.garagens = res.data.map(gar => {              
              return { ... gar, value:  gar.id_filial, garagem: gar.garagem }              
            })            
          })          
      },

}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>


</style>